import { UtilHelper } from '../../../shared/helpers/utils.helper';
import { RejectReason } from '../enums/reject-reason.enum';

export class OrderRejectReason {
  orderId?: number;
  note: string;
  reason: RejectReason;
  // employeeId: number;

  // // variáveis para o método de updatestatus
  // status?: string; // OrderStatus
  // isGroup?: boolean;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (this.reason != null && this.reason['code'] == null) {
      this.reason = UtilHelper.getEnumByCod(this.reason, RejectReason);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/orders/models/order-reject-reason.model.ts